import { createRoot } from 'react-dom/client';

// ログイン画面（旧 public/js/app/src/login.js。React 0.14 の React.render で描画していた）
// 文言・URL・CSRF トークンは auth/login.blade.php が window.BESMART_LOGIN に出力する
const L = window.BESMART_LOGIN || {};

function SignIn() {
  return (
    <div>
      <form className="signin" method="post" action={L.urlAuth}>
        <div className="field">
          <input className="email" placeholder={L.placeholderEmail} name="email" />
        </div>
        <div className="field">
          <input className="password" placeholder={L.placeholderPassword} name="password" type="password" />
          <button type="submit">{L.placeholderLogin}</button>
        </div>
        <div className="field">
          <label>
            <input type="checkbox" name="remember" />
            <span>{L.placeholderHoldlogin}</span>
          </label>
        </div>
        <div className="field">
          <a href={L.urlRemember} className="small_link">
            {L.placeholderForget}
          </a>
        </div>
        <input type="hidden" name="_token" value={L.token} />
      </form>
    </div>
  );
}

const el = document.getElementById('signin-container');
if (el) createRoot(el).render(<SignIn />);
